import React from 'react'
import { formatDifference } from '../../utils/formatDifference'

const COLOR_THRESHOLD_PERCENT = 20

interface DosingDifferencePercentProps {
  percent: number | null
  placeholder?: string
}

const percentColorClass = (percent: number): string => {
  if (percent > COLOR_THRESHOLD_PERCENT) return 'text-success'
  if (percent < -COLOR_THRESHOLD_PERCENT) return 'text-danger'

  return ''
}

const DosingDifferencePercent = ({ percent, placeholder = '-' }: DosingDifferencePercentProps) => {
  if (percent == null) {
    return <>{placeholder}</>
  }

  return <span className={percentColorClass(percent)}>{formatDifference(percent)}%</span>
}

export default DosingDifferencePercent
